/* eslint-disable no-unused-vars */
import axios from "axios";

export const fetchAllByMe = async (
  profileUserName = undefined,
  profileUserId = undefined
) => {
  try {
    const userObj = localStorage.getItem("salla_discourse_user");
    const user = JSON.parse(userObj);
    let username;
    let user_id;
    if (!profileUserName && user) {
      username = user.username;
    } else {
      username = profileUserName;
    }

    if (!profileUserId && user) {
      user_id = user.id;
    } else {
      user_id = profileUserId;
    }
    const encodedUsername = encodeURIComponent(username); // Encode for URL
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/user_actions.json?offset=0&username=${encodedUsername}&filter=4,5`,
      {
        /* headers: {
          "Api-Key": `${process.env.REACT_APP_API_KEY}`,
          "Api-Username": user_id,
          "Content-Type": "application/json",
        }, */
      }
    );
    const posts = response.data.user_actions.filter(
      (user_action) => !user_action.closed
    );
    return posts;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchTopicsCreatedByMe = async (
  profileUserName = undefined,
  profileUserId = undefined
) => {
  try {
    const userObj = localStorage.getItem("salla_discourse_user");
    const user = JSON.parse(userObj);
    let username;
    let user_id;
    if (!profileUserName && user) {
      username = user.username;
    } else {
      username = profileUserName;
    }

    if (!profileUserId && user) {
      user_id = user.id;
    } else {
      user_id = profileUserId;
    }
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/topics/created-by/${encodeURIComponent(
        username
      )}`,
      {
        /* headers: {
          "Api-Key": `${process.env.REACT_APP_API_KEY}`,
          "Api-Username": user_id,
          "Content-Type": "application/json",
        }, */
      }
    );
    const posts = response.data.topic_list.topics.filter(
      (topic) => !topic.closed
    );
    return posts;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchRepliesByMe = async (
  profileUserName = undefined,
  profileUserId = undefined
) => {
  try {
    const userObj = localStorage.getItem("salla_discourse_user");
    const user = JSON.parse(userObj);
    let username;
    let user_id;
    if (!profileUserName && user) {
      username = user.username;
    } else {
      username = profileUserName;
    }

    if (!profileUserId && user) {
      user_id = user.id;
    } else {
      user_id = profileUserId;
    }
    const response = await axios.get(
      `${
        process.env.REACT_APP_API_URL
      }/user_actions.json?offset=0&username=${encodeURIComponent(
        username
      )}&filter=5`,
      {
        /* headers: {
          "Api-Key": `${process.env.REACT_APP_API_KEY}`,
          "Api-Username": user_id,
          "Content-Type": "application/json",
        }, */
      }
    );
    const posts = response.data.user_actions.filter(
      (user_action) => !user_action.closed
    );
    return posts;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchMyReactedPosts = async (
  profileUserName = undefined,
  profileUserId = undefined
) => {
  try {
    const userObj = localStorage.getItem("salla_discourse_user");
    const user = JSON.parse(userObj);
    let username;
    let user_id;
    if (!profileUserName && user) {
      username = user.username;
    } else {
      username = profileUserName;
    }

    if (!profileUserId && user) {
      user_id = user.id;
    } else {
      user_id = profileUserId;
    }
    const response = await axios.get(
      `${
        process.env.REACT_APP_API_URL
      }/discourse-reactions/posts/reactions.json?username=${encodeURIComponent(
        username
      )}`,
      {
        /* headers: {
          "Api-Key": `${process.env.REACT_APP_API_KEY}`,
          "Api-Username": user_id,
          "Content-Type": "application/json",
        }, */
      }
    );
    const posts = response.data;
    return posts;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchMyAnsweredPosts = async (
  profileUserName = undefined,
  profileUserId = undefined
) => {
  try {
    const userObj = localStorage.getItem("salla_discourse_user");
    const user = JSON.parse(userObj);
    let username;
    let user_id;
    if (!profileUserName && user) {
      username = user.username;
    } else {
      username = profileUserName;
    }

    if (!profileUserId && user) {
      user_id = user.id;
    } else {
      user_id = profileUserId;
    }
    const response = await axios.get(
      `${
        process.env.REACT_APP_API_URL
      }/user_actions.json?offset=0&username=${encodeURIComponent(
        username
      )}&filter=15`,
      {
        /* headers: {
          "Api-Key": `${process.env.REACT_APP_API_KEY}`,
          "Api-Username": user_id,
          "Content-Type": "application/json",
        }, */
      }
    );
    const posts = response.data.user_actions || [];
    return posts;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchMyReadLaterPosts = async (
  profileUserName = undefined,
  profileUserId = undefined
) => {
  try {
    const userObj = localStorage.getItem("salla_discourse_user");
    const user = JSON.parse(userObj);
    let username;
    let user_id;
    if (!profileUserName && user) {
      username = user.username;
    } else {
      username = profileUserName;
    }

    if (!profileUserId && user) {
      user_id = user.id;
    } else {
      user_id = profileUserId;
    }
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/u/${encodeURIComponent(
        username
      )}/bookmarks.json?q=&acting_username=${encodeURIComponent(username)}`,
      {
        /* headers: {
          "Api-Key": `${process.env.REACT_APP_API_KEY}`,
          "Api-Username": user_id,
          "Content-Type": "application/json",
        }, */
      }
    );
    if (response.data.user_bookmark_list) {
      const posts = response.data.user_bookmark_list.bookmarks.filter(
        (bookmark) => !bookmark.closed
      );
      return posts;
    }
    return [];
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchCategories = async (is_include_subcategories = false) => {
  try {
    let url = `${process.env.REACT_APP_API_URL}/categories.json`;
    if (is_include_subcategories) {
      url = `${process.env.REACT_APP_API_URL}/categories.json?include_subcategories=true`;
    }

    const response = await axios.get(url);

    const filteredCategories = response.data.category_list.categories.filter(
      (category) => category.id !== 3 && category.id !== 4
    );
    const categories = filteredCategories.sort((a, b) =>
      a.subcategory_count === null ? -1 : 1
    );

    return categories;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchTags = async (categoryId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/tags/filter/search.json?filterForInput=true`
    );
    const tags = response.data?.results.map((tag) => ({
      ...tag,
      id: tag.id,
      value: tag.name,
      label: tag.name,
    }));
    return tags;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const searchTags = async (query) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/tags/filter/search.json?q=${query}&limit=5&filterForInput=true`
    );
    const tags = response.data?.results.map((tag) => ({
      ...tag,
      id: tag.id,
      value: tag.name,
      label: tag.name,
    }));
    return tags;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchAllNotifications = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/notifications.json?limit=30&recent=true&bump_last_seen_reviewable=true`
    );

    const allowedTypes = [1, 2, 25];
    const notifications = response.data.notifications.filter((notification) =>
      allowedTypes.includes(notification.notification_type)
    );
    const reports = response.data.pending_reviewables;
    const counts = notifications.reduce(
      (acc, notification) => {
        acc.allCount += 1;
        switch (notification.notification_type) {
          case 1: // Mention
            acc.mentionCount += 1;
            break;
          case 2: // Reply
            acc.replyCount += 1;
            break;
          case 25: // Reaction
            acc.reactionCount += 1;
            break;
          default:
            break;
        }
        return acc;
      },
      { allCount: 0, replyCount: 0, mentionCount: 0, reactionCount: 0 }
    );
    return { notifications, counts, reports };
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};
